import { motion } from "framer-motion";
import { Wand2 } from "lucide-react";
import { BraceletPreview } from "@/components/BraceletPreview";
import { CHARACTERS } from "@/components/tgcfData";
import { useMakeBracelet } from "@/hooks/useMakeBracelet";
import { useCharm } from "@/hooks/useCharm";

const slug = (s) => s.toLowerCase().replace(/\s/g, "-");

const CharacterCard = ({ c, i, prefix, accentSoft, cardClass, charm }) => {
  const make = useMakeBracelet();
  const showCharm = useCharm(charm);
  const makeIt = () => { make(c.beads, c.image); showCharm(); };
  return (
    <motion.article initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.7, delay: (i % 4) * 0.06 }} data-testid={`${prefix}-${slug(c.name)}`}
      className={`group relative overflow-hidden rounded-[22px] border p-4 sm:p-5 flex flex-col items-center text-center transition-colors ${cardClass}`}>
      <div className="relative flex flex-col items-center w-full">
      <BraceletPreview beads={c.beads} className="max-w-[160px] transition-transform duration-700 group-hover:rotate-12" />
      <p className="mt-3 font-display text-xl sm:text-2xl leading-tight">{c.name}</p>
      <p className={`mt-1 text-xs sm:text-sm italic ${accentSoft}`}>{c.title}</p>
      <button onClick={makeIt} data-testid={`${prefix}-make-${slug(c.name)}`}
        className="mt-4 inline-flex items-center gap-2 rounded-full border border-purple-200/40 px-4 py-2 text-sm hover:border-amber-200 hover:text-amber-200 transition-colors">
        <Wand2 className="w-4 h-4" /> <span className="sm:hidden">Make it</span><span className="hidden sm:inline">Make this bracelet</span>
      </button>
      </div>
    </motion.article>
  );
};

export const CharacterGallery = ({
  characters = CHARACTERS, prefix = "tgcf-gallery", accentText = "text-red-300", accentSoft = "text-red-200/90",
  blurb = "Every soul from the quiz, in their own colors. Pick one and make it yours for $10.",
  cardClass = "border-purple-200/15 bg-[#170a24]/80 hover:border-purple-100/40", charm,
}) => (
  <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 mt-20" data-testid={prefix}>
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
      <h3 className="font-display text-4xl md:text-5xl leading-none">All character <em className={accentText}>bracelets</em></h3>
      <p className="text-sm text-purple-100/85 max-w-sm">{blurb}</p>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
      {characters.map((c, i) => <CharacterCard key={c.name} c={c} i={i} prefix={prefix} accentSoft={accentSoft} cardClass={cardClass} charm={charm} />)}
    </div>
  </div>
);
